import { useContext } from 'react';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Grid, Icon, LinearProgress } from '@mui/material';
import { useForm } from 'react-hook-form';
import { CustomPagination } from 'utils/functions';
import { dropBoolean, dropTipoReintegracao } from 'utils/drops';
import { useDialog } from 'components/Modals';
import { GridContext } from 'contexts/GridContext';
import InputMask from 'components/InputMask';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Input from 'components/Input';
import Title from '../Components/Title';
import localeText from 'utils/localeText';
import moment from 'moment';

const Reintegracao = ({ loading, pessoal = {}, onSubmit, onDelete }) => {
  const { openDialog } = useDialog();
  const reintegracoes = pessoal?.Reintegracoes ?? [];

  const Modal = ({ item }) => {
    const defaultValues = {
      rotina: 'PessoalReintegracao',
      id: item?.id,
      pessoal_id: pessoal?.id,
      tpreint: item?.tpreint || null,
      nrprocjud: item?.nrprocjud || '',
      nrleianistia: item?.nrleianistia || '',
      dtefetretorno: item?.dtefetretorno || null,
      dtefeito: item?.dtefeito || null,
      indpagjuiso: item?.indpagjuiso || null,
    };
    const { postLoading } = useContext(GridContext);
    const { control, handleSubmit } = useForm({ defaultValues });

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Title title="Identificação da reintegração" disableMargin />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="tpreint"
            control={control}
            label="Tipo de Reintegração"
            options={dropTipoReintegracao}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Input
            name="nrprocjud"
            control={control}
            label="Nº do Processo Judicial"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Input
            name="nrleianistia"
            control={control}
            label="Nº da Lei de Anistia"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Datas" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputMask
            type="date"
            control={control}
            name="dtefetretorno"
            label="Data de Efetivo Retorno"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputMask
            type="date"
            name="dtefeito"
            control={control}
            label="Data de Efeito Retroativo"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Aspectos Financeiros" />
        </Grid>
        <Grid item xs={12}>
          <Dropdown
            control={control}
            name="indpagjuiso"
            options={dropBoolean}
            label="Pagamento Judicial"
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            color="primary"
            loading={postLoading}
            variant="contained"
            onClick={handleSubmit(onSubmit)}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Title
          title="Reintegrações"
          disableMargin
          rightButton={
            <Button
              color="primary"
              variant="outlined"
              onClick={() => openDialog(<Modal />, 'Adicionar Reintegração')}
            >
              Adicionar
            </Button>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          rows={reintegracoes}
          columns={[
            {
              field: 'tpreint',
              headerName: 'Tipo',
              minWidth: 300,
              flex: 1,
              sortable: false,
            },
            {
              field: 'nrprocjud',
              headerName: 'Nº do Processo Judicial',
              width: 200,
              sortable: false,
            },
            {
              field: 'nrleianistia',
              headerName: 'Nº da Lei de Anistia',
              width: 200,
              sortable: false,
            },
            {
              field: 'dtefetretorno',
              headerName: 'Data de Efetivo Retorno',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'dtefeito',
              headerName: 'Data de Efeito Retroativo',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'indpagjuiso',
              headerName: 'Pagamento Judicial',
              width: 200,
              sortable: false,
            },
            {
              field: 'actions',
              headerName: 'Ações',
              type: 'actions',
              width: 100,
              getActions: ({ row }) => [
                <GridActionsCellItem
                  icon={<Icon>edit</Icon>}
                  label="Editar"
                  onClick={() =>
                    openDialog(<Modal item={row} />, 'Editar Reintegração')
                  }
                />,
                <GridActionsCellItem
                  icon={<Icon>delete</Icon>}
                  label="Excluir"
                  onClick={() =>
                    onDelete({ rotina: 'PessoalReintegracao', id: row?.id })
                  }
                />,
              ],
            },
          ]}
          autoHeight
          pagination
          pageSize={10}
          density="compact"
          loading={loading}
          disableColumnMenu
          showCellRightBorder
          showColumnRightBorder
          disableSelectionOnClick
          localeText={localeText}
          getRowHeight={() => 'auto'}
          components={{
            Pagination: CustomPagination,
            LoadingOverlay: LinearProgress,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default Reintegracao;
